import { useApolloClient, useLazyQuery, useQuery } from "@apollo/client";
import { useCallback } from "react";
import { gql } from "../../__generated__";
import { ObjectDescription } from "../../__generated__/graphql";

export const MY_GENERATIONS = gql(`
  query MyGenerations($limit: Int, $cursor: String) {
    myAiGenerationsAnonymous(limit: $limit, cursor: $cursor) {
      data {
        ...GenerationCompleteFragment
      }
      nextCursor
    }
  }
`);

export function useMyGenerationsQuery(variables?: {
  limit?: number;
  cursor?: string;
}) {
  return useQuery(MY_GENERATIONS, {
    variables,
    fetchPolicy: "cache-and-network",
  });
}

export function useMyGenerationsPrefetch() {
  const client = useApolloClient();
  return useCallback(() => client.query({ query: MY_GENERATIONS }), [client]);
}

const GET_GENERATIONS_PROGRESS = gql(`
  query GetGenerationsProgress($generationsIds: [String!]!) {
    getGenerationsAnonymous(generationsIds: $generationsIds) {
      ...GenerationFragment
    }
  }
`);

export function useGetGenerationsProgress() {
  return useLazyQuery(GET_GENERATIONS_PROGRESS, {
    notifyOnNetworkStatusChange: true,
    fetchPolicy: "network-only",
  });
}

const GET_GENERATIONS_COMPLETE = gql(`
  query GetGenerationsComplete($generationsIds: [String!]!) {
    getGenerationsAnonymous(generationsIds: $generationsIds) {
      ...GenerationCompleteFragment
    }
  }
`);

export function useGetGenerationsComplete() {
  return useLazyQuery(GET_GENERATIONS_COMPLETE, {
    notifyOnNetworkStatusChange: true,
    fetchPolicy: "network-only",
  });
}

export function useGetGenerationsByIds(ids: string[]) {
  return useQuery(GET_GENERATIONS_COMPLETE, {
    variables: { generationsIds: ids },
  });
}

const GET_GENERATION_BY_DETECTED_OBJECT = gql(`
  query GetGenerationsByDetectedObjects($objectDescriptionToUse: ObjectDescription) {
    getGenerationsByDetectedObjectsAnonymous(objectDescriptionToUse: $objectDescriptionToUse) {
      items {
        previewUrl
        detectedObject
        generations {
          generationId
          aspectRatio
        }
      }
    }
  }
`);

export function useGenerationByDetectedObject() {
  return useQuery(GET_GENERATION_BY_DETECTED_OBJECT, {
    variables: {
      objectDescriptionToUse: ObjectDescription.Short,
    },
  });
}
